import HelpCenterLayout from "@components/helpCenter/HelpCenterLayout"
import { ResultView, StoreLink } from "@components/helpCenter/ResultParts"
import { useTranslation } from "react-i18next"

export default function RefundApplePage() {
  const { t } = useTranslation()

  return (
    <HelpCenterLayout>
      <ResultView
        icon="warning"
        title={t("pages.helpCenter.activeAppleSubscription")}
      >
        <p>{t("pages.helpCenter.refundApple.followAppleInstructions")}</p>

        <StoreLink url="https://support.apple.com/118223" />
      </ResultView>
    </HelpCenterLayout>
  )
}
